import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <div className="card-soft p-8 md:p-10 grid md:grid-cols-2 gap-10">
        <div>
          <h1 className="font-display font-bold text-3xl sm:text-4xl">Contact Us</h1>
          <p className="mt-3 text-lg" style={{ color: "var(--text-muted)" }}>
            Questions about setup, pricing, or a demo for your boutique? We&apos;re happy to help.
          </p>
          <div className="mt-8 space-y-4 text-sm">
            <a href="mailto:hello@vastrakiran.com" className="flex items-center gap-3 hover:opacity-80" style={{ color: "var(--text-main)" }}>
              <Mail size={18} style={{ color: "var(--primary)" }} />
              hello@vastrakiran.com
            </a>
            <div className="flex items-center gap-3" style={{ color: "var(--text-muted)" }}>
              <Phone size={18} style={{ color: "var(--primary)" }} />
              +91 98765 43210
            </div>
            <div className="flex items-start gap-3" style={{ color: "var(--text-muted)" }}>
              <MapPin size={18} className="shrink-0 mt-0.5" style={{ color: "var(--primary)" }} />
              Hyderabad, Telangana, India
            </div>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium">Your name</label>
            <input className="mt-1.5 w-full h-11 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }} placeholder="Boutique owner name" />
          </div>
          <div>
            <label className="text-sm font-medium">Email</label>
            <input type="email" className="mt-1.5 w-full h-11 px-3 rounded-md border bg-white" style={{ borderColor: "var(--border-soft)" }} placeholder="you@store.com" />
          </div>
          <div>
            <label className="text-sm font-medium">Message</label>
            <textarea rows={4} className="mt-1.5 w-full px-3 py-2 rounded-md border bg-white resize-none" style={{ borderColor: "var(--border-soft)" }} placeholder="Tell us about your store..." />
          </div>
          <a
            href="mailto:hello@vastrakiran.com?subject=VastraKiran%20enquiry"
            className="inline-flex items-center justify-center w-full h-11 rounded-md text-white font-semibold tactile-btn"
            style={{ background: "var(--primary)" }}
          >
            Send message
          </a>
        </div>
      </div>
    </section>
  );
}
